/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../../../../_metronic/helpers'
import {ServiceByPointModel} from '../../../../../../model'
import {getAssignService} from '../../../../../../services'
import {deleteAssignService} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ModalAddService} from '../modal/ModalAddService'
import Swal from 'sweetalert2'

const TableServices: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [showModalNew, setShowModalNew] = useState(false)

  const handleClear = () => {
    // setIdPermission('')
  }
  const getAssignServiceList = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getAssignService(
        currentTabItem.idToEdit,
        pagination.currentPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAssignServiceList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getAssignServiceList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<ServiceByPointModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombre' />,
      accessor: 'nombre',
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        // const mappedSelected = selected.map((item) => ({Id: item}))

        let obj = {
          puntoId: currentTabItem.idToEdit,
          services: [selectedOn[0]],
        }
        const {data: response} = await deleteAssignService(obj)
        if (!response.error) {
          getAssignServiceList()
        }
        getAssignServiceList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('ASIGSERVICIO/AGREGAR') && (
            <button type='button' className='btn btn-success me-3' onClick={handleNew}>
              Agregar
            </button>
          )}

          {isAllowed('ASIGSERVICIO/ELIMINAR') && (
            <button
              type='button'
              className='btn btn-primary me-3'
              disabled={selectedOn.length < 1}
              onClick={handleDelete}
            >
              Eliminar
            </button>
          )}
        </div>
        {isAllowed('ASIGSERVICIO/LISTAR') && (
          <>
            <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}

        <ModalAddService
          show={showModalNew}
          setShow={setShowModalNew}
          getAssignServiceList={getAssignServiceList}
          setIdPermissionList={handleClear}
        />
      </KTCard>
    </>
  )
}

const TableServicesWrapper = () => {
  return (
    <KTableProvider>
      <TableServices />
    </KTableProvider>
  )
}
export {TableServicesWrapper}
